// extracted by mini-css-extract-plugin
export default {"cog":"CompanySwitcher_cog__+MgVC","button":"CompanySwitcher_button__gjirV"};